import { CardActions, CardMedia, Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative',
        backgroundColor: theme.palette.ascents.baseDark,
        padding: '0.5rem 0',
        border: `1px solid ${theme.palette.primary.main}`,

        '&:before': {
            display: 'block',
            content: '""',
            width: '100%',
            paddingTop: ({ aspectRatio }) => `calc((${aspectRatio}) * 100%)`,
        },
    },
    contentContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,

        '& .MuiCardContent-root': {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    media: {
        display: 'flex',
        height: '100%'
    }
}));

const AppCard = ({
    heading = '',
    headingTop = '',
    headingBottom = '',
    mainContent,
    actionComponent,
    headingProps,
    cardWrapeprProps,
    imageUrl,
    imageProps,
    containerProps,
    aspectRatio = 9 / 16
}) => {
    const classes = useStyles({
        aspectRatio,
    });

    return (
        <Card className={classes.root} {...cardWrapeprProps}>
            <Grid className={classes.contentContainer} container {...containerProps}>
                <Grid item xs={!!imageUrl ? 8 : 12}>
                    <CardContent>
                        {
                            !!headingTop &&
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                {headingTop}
                            </Typography>
                        }
                        <Typography variant="h5" component="h2" {...headingProps}>
                            {heading}
                        </Typography>
                        {
                            !!headingBottom &&
                            <Typography className={classes.pos} color="textSecondary">
                                adjective
                            </Typography>
                        }
                        {mainContent}
                    </CardContent>
                </Grid>
                {
                    !!imageUrl &&
                    <Grid xs={4}>
                        <CardMedia className={classes.media}>
                            <img src={imageUrl} alt='icon' {...imageProps} />
                        </CardMedia>
                    </Grid>
                }
                {
                    !!actionComponent &&
                    <Grid xs={12}>
                        <CardActions>
                            {actionComponent}
                        </CardActions>
                    </Grid>
                }
            </Grid>
        </Card>
    );
}

export default AppCard;